/* Cart drawer extras: shipping protection, tip, gift note */
(function () {
  'use strict';
  var R = window.lpRoutes || {};

  function ajax(url, fallback) {
    var u = url || fallback;
    if (u.indexOf('?') > -1) u = u.split('?')[0];
    if (u.slice(-3) !== '.js') u += '.js';
    return u;
  }
  var ADD = ajax(R.cartAdd, '/cart/add');
  var CHANGE = ajax(R.cartChange, '/cart/change');
  var CART = (R.cart || '/cart').split('?')[0];

  var busy = false;

  function refresh() {
    return fetch(CART + '?section_id=lp-cart-drawer-section', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-lp-drawer-inner]');
        var live = document.querySelector('[data-lp-drawer-inner]');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
        var c = doc.querySelector('[data-lp-cart-count]');
        [].slice.call(document.querySelectorAll('[data-lp-cart-count]')).forEach(function (n) {
          if (c) n.textContent = c.textContent;
        });
      })
      .catch(function () {});
  }

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function lock(el) {
    if (busy) return false;
    busy = true;
    if (el) el.style.opacity = '.5';
    return true;
  }
  function unlock(el) {
    busy = false;
    if (el) el.style.opacity = '';
  }

  /* --- shipping protection toggle --- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lp-addon]');
    if (!b) return;
    e.preventDefault();
    if (!lock(b)) return;
    var on = b.getAttribute('aria-pressed') === 'true';
    var key = b.getAttribute('data-lp-addon-key');
    var req = on && key
      ? post(CHANGE, { id: key, quantity: 0 })
      : post(ADD, { items: [{ id: Number(b.getAttribute('data-lp-addon-id')), quantity: 1 }] });
    req.then(refresh).catch(function () {}).then(function () { unlock(b); });
  });

  /* --- tip --- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-lp-tip]');
    if (t) {
      e.preventDefault();
      if (!lock(t)) return;
      var id = Number(t.getAttribute('data-lp-tip-id'));
      var key = t.getAttribute('data-lp-tip-key');
      var active = t.classList.contains('is-active');
      var chain = key ? post(CHANGE, { id: key, quantity: 0 }) : Promise.resolve();
      chain
        .then(function () {
          if (active) return null;
          return post(ADD, { items: [{ id: id, quantity: 1 }] });
        })
        .then(refresh)
        .catch(function () {})
        .then(function () { unlock(t); });
      return;
    }
    var clear = e.target.closest('[data-lp-tip-clear]');
    if (clear) {
      e.preventDefault();
      if (!lock(clear)) return;
      post(CHANGE, { id: clear.getAttribute('data-lp-tip-key'), quantity: 0 })
        .then(refresh).catch(function () {}).then(function () { unlock(clear); });
    }
  });

  /* --- bundle upsell label (kept for any tier that still carries a pair id) --- */
  document.addEventListener('click', function (e) {
    var tier = e.target.closest('[data-lp-tier]');
    if (!tier) return;
    setTimeout(function () {
      var form = tier.closest('form');
      if (!form) return;
      var atc = form.querySelector('[data-lp-atc]');
      if (!atc || atc.disabled) return;
      var active = form.querySelector('[data-lp-tier].is-active');
      var base = atc.getAttribute('data-lp-label') || 'Add to Bag';
      var both = atc.getAttribute('data-lp-label-both') || 'Add both to bag';
      atc.textContent = active && active.getAttribute('data-lp-pair-id') ? both : base;
    }, 0);
  });

  /* --- gift note (debounced save) --- */
  var noteTimer = null;
  document.addEventListener('input', function (e) {
    var ta = e.target.closest('[data-lp-note]');
    if (!ta) return;
    clearTimeout(noteTimer);
    var status = document.querySelector('[data-lp-note-status]');
    if (status) status.textContent = 'Saving...';
    noteTimer = setTimeout(function () {
      post('/cart/update.js', { note: ta.value })
        .then(function () { if (status) status.textContent = 'Note saved'; })
        .catch(function () { if (status) status.textContent = ''; });
    }, 600);
  });
})();
